import { render, staticRenderFns } from "./TreatmentItemsSelectPopup.vue?vue&type=template&id=6f387fc4&scoped=true&"
import script from "./TreatmentItemsSelectPopup.vue?vue&type=script&lang=js&"
export * from "./TreatmentItemsSelectPopup.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentItemsSelectPopup.vue?vue&type=style&index=0&id=6f387fc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f387fc4",
  null
  
)

export default component.exports